export const convertDatetime = (datetimeStr: string) => {
  let date = new Date(datetimeStr);

  return date.toLocaleDateString('default', { day: '2-digit', month: '2-digit', year: 'numeric' });
};
